import React from 'react';

const FreeIcon = ({txt = 'free'}) => {
  return (
    <span style={{
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
      fontFamily: 'Roboto, sans-serif',
      fontSize: '12px',
      lineHeight: '16px',
      padding: '2px 4px',
      color: 'var(--poker-white)',
      background: txt === 'free' ? 'var(--poker-active-blue)' : 'var(--poker-dark)',
      borderRadius: '4px',
    }}
    >
      {txt}
    </span>
  );
};

export default FreeIcon;